import { Text } from '@factorialco/deprecated-design-system'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { Syncing } from 'modules/integrations/components/SyncFooter/LastSync/Syncing'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useIsExportMode } from 'modules/integrations/lib/capabilityModes'

const formatDate = (date: string): string => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

export const LastSync = () => {
  const { isSyncRunning, lastSyncRun } = useIntegrationsSyncContext()
  const isExportMode = useIsExportMode()

  if (isSyncRunning) return <Syncing />

  if (!lastSyncRun)
    return (
      <Text.Normal color="grey700" size="200">
        {isExportMode
          ? i18n.t('integrations.footer.no_last_export')
          : i18n.t('integrations.footer.no_last_sync')}
      </Text.Normal>
    )

  return (
    <>
      <Text.Normal color="grey700" size="200">
        {isExportMode
          ? i18n.t('integrations.footer.last_export')
          : i18n.t('integrations.footer.last_sync')}
      </Text.Normal>
      <Text.Normal color="grey800" size="200" weight="medium">
        {formatDate(lastSyncRun.finishedAt)}
      </Text.Normal>
    </>
  )
}
